import { FC } from 'react';
import ManageTokens from 'components/document-templates/components/ManageTokens';

const Screen: FC = () => {
  return (
    <ManageTokens
      tokensEntityName="tokens"
      tokensEndpoint="tokens"
      fieldsEntityName="fields"
      fieldsEndpoint="fields"
      tokenIdKey="token_id"
      fieldIdKey="field_id"
      templateFilter="template_id"
    />
  );
};

export default Screen;
